import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useGeneralStore } from '@/stores/general';

/**
 * The sso texts of the customer (set in the super-admin) for the current language. Only the current language is used,
 * a text from another language would be misleading. An empty text falls back to the default of the client.
 */
export function useSsoLabels() {
  const { locale, t: $t } = useI18n();
  const generalStore = useGeneralStore();

  const localization = computed(() => generalStore.customer().localizations?.[locale.value]);

  return {
    ssoPriceLabel: computed(() => localization.value?.sso_price_label || $t('common.sso_price')),
    regularPriceLabel: computed(() => localization.value?.regular_price_label || $t('common.regular_price')),
    welcomeLabel: computed(() => localization.value?.sso_welcome_label || $t('globals.sso_welcome')),
    exclusiveMessagePostfix: computed(() => localization.value?.sso_exclusive_message_postfix || ''),
    loginPromptText: computed(() => localization.value?.sso_login_prompt_text || ''),
    noAccessButtonText: computed(() => localization.value?.sso_no_access_button_text || $t('event.sso_no_access')),
  };
}
